import { render, staticRenderFns } from "./EditWheatIssueModal.vue?vue&type=template&id=104ec6db&"
import script from "./EditWheatIssueModal.vue?vue&type=script&lang=js&"
export * from "./EditWheatIssueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports